// extracted by mini-css-extract-plugin
export default {"row":"PromoCodeRow_row__qNHUB","name":"PromoCodeRow_name__r9e+x","value":"PromoCodeRow_value__grpvZ"};